import { Modal } from "@circle-react-shared/uikit/ModalV2";
import { ModalCloseButton } from "@circle-react-shared/uikit/ModalV2/ModalCloseButton";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { PROFILE_PAGES } from "@circle-react/helpers/memberHelper";

import { t } from "@/i18n-js/instance";
import { useAgentProfileInfo } from "@/react/hooks/agent_profile/useAgentProfileInfo";

import { AgentProfile } from "./AgentProfile";

const pageParams = {
  page_name: PROFILE_PAGES.PROFILE_VIEW,
};

interface AgentProfileModalUIKitComponentProps {
  agentId: number;
}

export const AgentProfileModalUIKitComponent = ({
  agentId,
}: AgentProfileModalUIKitComponentProps) => {
  const modal = useModal();
  const isOpen = modal.visible;
  const onClose = () => modal.remove();
  const {
    getAgentProfileInfoQuery: { data: agent, isInitialLoading: isLoading },
  } = useAgentProfileInfo({
    agentId,
    params: pageParams,
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentPortalId="post-modal-portal"
    >
      <Modal.Overlay />
      <Modal.Content size="2xl" className="max-w-screen-xl">
        <div className="border-primary text-dark flex justify-between border-b !px-9 !py-4">
          <Typography.TitleSm weight="semibold">
            {t("profile")}
          </Typography.TitleSm>
          <ModalCloseButton onClick={onClose} />
        </div>
        <Modal.Body className="!md:px-0 !md:pt-0 !md:overflow-hidden block grid-cols-12 !p-0 md:grid md:grid-flow-row-dense">
          <AgentProfile agent={agent} isLoading={isLoading} onClose={onClose} />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};
